import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export const formAddNewSubEntitySettingsList = [
  ContactSlugEnum.FirstName,
  ContactSlugEnum.Surname,
  ContactSlugEnum.PhoneNumber,
  ContactSlugEnum.CompanyName,
  ContactSlugEnum.Country,
  ContactSlugEnum.State,
  ContactSlugEnum.City,
  ContactSlugEnum.Neighborhood,
  ContactSlugEnum.StreetAddress,
  ContactSlugEnum.StreetNumber,
  ContactSlugEnum.Postcode,
  ContactSlugEnum.TaxNumber,
]
